import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { MessageCircle, ChevronRight, Trash2 } from 'lucide-react';

export default function AdminSupportPage() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => { try { const { data } = await api.get('/support'); setTickets(data.tickets || []); } catch (e) {} finally { setLoading(false); } };
  useEffect(() => { load(); }, []);

  const deleteTicket = async (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    if (!window.confirm('Eliminare questo ticket e tutti i messaggi?')) return;
    try { await api.delete(`/support/admin/${id}`); toast.success('Ticket eliminato'); load(); }
    catch (err) { toast.error('Errore'); }
  };

  const statusColors = { open: 'bg-green-600', in_progress: 'bg-blue-600', resolved: 'bg-gray-600', closed: 'bg-gray-700' };
  const priorityColors = { urgent: 'border-l-4 border-l-red-500', normal: '' };

  return (
    <div>
      <h1 className="text-2xl font-bold text-white mb-6">Supporto ({tickets.length})</h1>
      {loading ? <div className="flex justify-center py-16"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-400" /></div> : (
        <div className="space-y-3">{tickets.length === 0 ? (
          <div className="card-dark p-12 text-center text-gray-500">Nessun ticket di supporto</div>
        ) : tickets.map(t => (
          <Link key={t.id} to={`/support/${t.id}`} className={`card-dark p-4 flex items-center gap-4 hover:border-gray-600 transition block ${priorityColors[t.priority]}`}>
            <MessageCircle size={18} className={t.unread > 0 ? 'text-yellow-400' : 'text-gray-500'} />
            <div className="flex-1 min-w-0"><p className="font-medium text-white truncate">{t.subject}</p><p className="text-xs text-gray-400">{t.first_name} {t.last_name} · {t.category} · {new Date(t.updated_at).toLocaleDateString('it-IT')}</p></div>
            <span className={`text-[10px] px-2 py-1 rounded-full text-white ${statusColors[t.status]}`}>{t.status}</span>
            {t.unread > 0 && <span className="w-5 h-5 bg-yellow-500 text-gray-900 text-xs rounded-full flex items-center justify-center font-bold">{t.unread}</span>}
            <button onClick={(e) => deleteTicket(e, t.id)} className="p-1.5 text-gray-600 hover:text-red-500 z-10"><Trash2 size={14} /></button>
            <ChevronRight size={16} className="text-gray-600" />
          </Link>
        ))}</div>
      )}
    </div>
  );
}
